<template>
<div v-if="!$root.appConfig.container"
     class="odr-chat-window"
     :class="{
         'odr-chat-window_position-left': $root.appConfig.chatPositionLeft
     }"
     :style="`width: ${$root.appConfig.chatWidth}px !important;
              margin-${$root.appConfig.chatPositionLeft ? 'left' : 'right'}: ${$root.appConfig.chatMarginSide}px !important;
              margin-bottom: ${$root.appConfig.chatMarginBottom}px !important;`">
    <div class="odr-chat-wrap odr-g-widget-mode-chat"
         :class="{
             'odr-chat-wrap_fullscreen': $root.appConfig.chatModeFullScreen,
         }"
         :style="!$root.appConfig.chatModeFullScreen ? `height: ${chatHeight + additionalHeight}px !important;` : `height: 100% !important;`">
        <div class="odr-chat-wrap__sizer"
             draggable
             @drag="onDrag"/>
        <slot/>
    </div>
</div>
<span v-else class="odr-chat-wrap odr-g-widget-mode-chat">
    <slot/>
</span>
</template>

<script>
import '@/scss/blocks/chat-wrap.scss';
import '@/scss/blocks/chat-window.scss';
import { mapState } from 'vuex';
import Vue from 'vue';

export default {
    data () {
        return {
            dragY: 0,
        };
    },
    watch: {
        dragY (value, old) {
            if (old && value) {
                this.additionalHeight -= value - old;
            }
        },
        maxAdditionalHeight () {
            // eslint-disable-next-line no-self-assign
            this.additionalHeight = this.additionalHeight; // trigger setter
        },
    },
    computed: {
        ...mapState('dimensions', {
            dimensionsWindowHeight: 'windowHeight',
        }),
        chatHeight () {
            if (typeof (this.$root.appConfig.chatHeight) === 'string' &&
                this.$root.appConfig.chatHeight[this.$root.appConfig.chatHeight.length - 1] === '%'
            ) {
                let [percentageStr] = this.$root.appConfig.chatHeight.split('%');
                return Math.max(window.innerHeight * (parseInt(percentageStr) / 100), 400);
            } else if (typeof (this.$root.appConfig.chatHeight) === 'number') {
                return this.$root.appConfig.chatHeight;
            } else {
                Vue.config.errorHandler('Wrong widget config property value', this, this.$root.appConfig.chatHeight);
                return 0;
            }
        },
        additionalHeight: {
            get () {
                return this.$store.state.local.chatAdditionalHeight;
            },
            set (value) {
                this.$store.commit('dimensions/SET_WIDGET_HEIGHT', this.$root.$el);
                this.$store.commit('local/SET', {
                    key: 'chatAdditionalHeight',
                    value: Math.max(Math.min(this.maxAdditionalHeight, value), -1 * this.chatHeight + 200),
                });
            },
        },
        maxAdditionalHeight () {
            return this.dimensionsWindowHeight - this.chatHeight - this.$root.appConfig.fixedTopFn() - this.$root.appConfig.chatMarginBottom;
        },
    },
    methods: {
        onDrag (event) {
            if (event.clientY === 0) {
                return;
            }
            this.dragY = event.clientY;
        },
    },
};
</script>
